import React from 'react';
import BasePageContainer from 'src/components/CommonV2Components/BasePageContainer/BasePageContainer';
import Flex from 'src/components/BeaconV2Components/Flex/Flex';
import { BEACON_CHART_SPACING } from 'src/components/Layout/Beacon/BeaconProLayoutConsts';
import AtlasV2OtherTrafficV2OtherSplineChart from 'src/components/AtlasV2Components/AtlasV2TrafficV2PageComponents/AtlasV2OtherTrafficV2/AtlasV2OtherTrafficV2OtherSplineChart';
import AtlasV2OtherTrafficV2ProductWithOtherTraffic from 'src/components/AtlasV2Components/AtlasV2TrafficV2PageComponents/AtlasV2OtherTrafficV2/AtlasV2OtherTrafficV2ProductWithOtherTraffic';
import { AtlasV2TrafficProductGrid } from 'src/components/AtlasV2Components/AtlasV2TrafficV2PageComponents/AtlasV2TotalTrafficV2/AtlasV2TrafficV2ProductGrid';
import { useProductEntity } from 'src/utils/Hooks/reduxSelectors';
import { useAtlasV2TabTreatmentRedirect } from 'src/components/AtlasV2Components/Hooks/useAtlasV2TabTreatmentRedirect';
/**
 * Atlas V2 Other Traffic V2 Page layout - Tab name: traffic subtab name: otherClicks
 */
export const AtlasV2OtherTrafficV2PageLayout = () => {
  const { isProductEntity } = useProductEntity();
  const { isRedirecting } = useAtlasV2TabTreatmentRedirect();
  if (isRedirecting) return null;

  return (
    <BasePageContainer>
      <Flex flexDirection="column" gap={BEACON_CHART_SPACING}>
        <AtlasV2OtherTrafficV2OtherSplineChart />
        {!isProductEntity && <AtlasV2OtherTrafficV2ProductWithOtherTraffic />}

        <AtlasV2TrafficProductGrid trafficType="otherClicks" />
      </Flex>
    </BasePageContainer>
  );
};
